import axios from "axios";
import { getApiRoute } from "src/services";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export async function upsertCalendarReview({ calendarId, accuracyStars, title, comment }) {
  if (!calendarId) {
    throw new Error("calendarId is required");
  }
  const response = await axios.post(
    getApiRoute("calendar", "UPSERT_CALENDAR_REVIEW", { calendarId }),
    { accuracyStars, title, comment },
    { withCredentials: true },
  );
  return { ...response.data, status: response.status };
}

export const useUpsertCalendarReview = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation(upsertCalendarReview, {
    ...options,
    onSuccess: (data, vars, ctx) => {
      queryClient.invalidateQueries(["calendar-reviews", vars.calendarId]);
      if (options.onSuccess) options.onSuccess(data, vars, ctx);
    },
  });
};
